export default{
    route:{
        home:'首页',  
        bonusList:'奖金榜',   
        picture:'图片',
        players:'球员',
        schedule:'赛事日程',
    },
    
}


// WEBPACK FOOTER //
// ./src/lang/zh.js